<!-- 产品质检报告 -->
<template>
    <div v-if="componentsData.type == 15">
        <div class="overflow-hidden bg-div"
            :style="componentsData.content.version ?
                {
                    ...(componentsData.content.bg_color && { backgroundColor: componentsData.content.bg_color }),
                    ...(componentsData.content.bg_img.picview && componentsData.content.bg_value && { backgroundImage: `url(${componentsData.content.bg_img.picview})` }),
                    padding: `${componentsData.content.paddingData.top}px ${componentsData.content.paddingData.left}px`,
                    margin: `${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px`,
                    borderRadius: `${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.bottom}px ${componentsData.content.radiusData.bottom}px`
                } : 
                `padding: ${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px;background: ${componentsData.content.bg_color};border-radius: ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.bottomRadius}px ${componentsData.content.marginData.bottomRadius}px`
            "
        >
            <div class="fw-bold flex-c" v-if="componentsData.content.style_value == 1"
                :style="`border-bottom: 1px solid ${componentsData.content.title_border_color};
                    background: ${componentsData.content.title_bg_color}; font-size: ${componentsData.content.title_size}px; color: ${componentsData.content.title_color};
                `"
            >
                <div class="dec-left" :style="{ background: decLeft }"></div>
                <div class="dec-content"> {{ componentsData.content.title }} </div>
                <div class="dec-right" :style="{ background: decRight }"></div>
            </div>
            <div v-else class="fw-bold"
                :style="`text-align: ${componentsData.content.position};border-bottom: 1px solid ${componentsData.content.title_border_color};
                    background: ${componentsData.content.title_bg_color}; font-size: ${componentsData.content.title_size}px; color: ${componentsData.content.title_color};
                `"
            >
                {{ componentsData.content.title }}
            </div>
            <div class="pt-6" :style="` font-size: ${componentsData.content.text_size}px; color: ${componentsData.content.text_color}; `" >
                <div class="mb-6">质检名称</div>
                <!-- 轮播 -->
                <Carousel v-if="componentsData.content.style_set == 1" radius-dot >
                    <CarouselItem v-for="(item, index) of componentsData.content.imgList" :key="index">
                        <img v-if="item.value" class="wh100" :src="item.picview"
                            :style="`border-radius: ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.bottomRadius}px ${componentsData.content.marginData.bottomRadius}px;`"
                        />
                        <div v-else class="wh100 w98"></div>
                    </CarouselItem>
                </Carousel>
                <!-- 平铺 -->
                <div v-else-if="componentsData.content.style_set == 2" class="h260" >
                    <imgStyle class="h100" :imageData="componentsData" :imgList="[]" ></imgStyle>
                </div>
                <!-- 单张预览 -->
                <div v-else class="preview-img" ></div>
            </div>
        </div>
    </div>
</template>

<script>
import imgStyle from "@/components/imgStyle/imgStyle.vue";
export default {
    components: {
        imgStyle,
    },
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {};
    },
    computed: {
        decLeft() {
            return `linear-gradient(to left, ${this.componentsData.content.dec_color}, transparent)`;
        },
        decRight() {
            return `linear-gradient(to right, ${this.componentsData.content.dec_color}, transparent)`;
        },
    },
    mounted() {},
    methods: {},
};
</script>

<style scoped>
.overflow-hidden {
    overflow: hidden;
}
.fw-bold {
    font-weight: bold;
    padding-bottom: 6px;
}
.content-div {
    border-radius: 10px;
    border: 1px solid #cccccc;
    background: #efefef;
    width: 200px;
}
.wh100 {
    width: 100%;
    height: 260px;
    border: 1px solid #cccccc;
}
.dec-left {
    margin: 0 12px;
    width: 50px;
    height: 4px;
    border-radius: 2px;
}
.dec-right {
    margin: 0 12px;
    width: 50px;
    height: 4px;
    border-radius: 2px;
}
.dec-content {
    max-width: 200px;
    white-space: nowrap; /* 确保文本不会换行 */
    overflow: hidden; /* 隐藏溢出的文本 */
    text-overflow: ellipsis; /* 显示省略号来代表被修剪的文本 */
}
.bg-div {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
.h260 {
    height: 260px;
}
.preview-img {
    height: 260px;
    width: 100%;
    border: 1px solid #ccc;
}
.pt-6 {
    padding-top: 6px;
}
.mb-6 {
    margin-bottom: 6px;
}
.w98 {
    width: 98%;
}
</style>